export default __webpack_public_path__ + "static/media/google-store-vi.35a712e7.svg";